import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState, } from 'react';
import classNames from 'classnames';
import { PREFIX_BS } from '../config';
export default function DStepper({ options, currentStep, className, style, }) {
    if (currentStep < 1 || currentStep > options.length) {
        throw new Error('Current step should be in the range from 1 to options length');
    }
    const currentOption = useMemo(() => { var _a; return (_a = options[currentStep - 1]) !== null && _a !== void 0 ? _a : {}; }, [currentStep, options]);
    const [currentAngle, setCurrentAngle] = useState(0);
    useEffect(() => {
        const targetAngle = (currentStep / options.length) * 360;
        const animationInterval = setInterval(() => {
            const angleDifference = targetAngle - currentAngle;
            const step = Math.sign(angleDifference) * 5;
            if (Math.abs(angleDifference) <= Math.abs(step)) {
                setCurrentAngle(targetAngle);
                clearInterval(animationInterval);
            }
            else {
                setCurrentAngle(currentAngle + step);
            }
        }, 16);
        return () => {
            clearInterval(animationInterval);
        };
    }, [currentAngle, currentStep, options.length]);
    const progressStyle = useMemo(() => `conic-gradient(
      from 0deg,
      var(--${PREFIX_BS}step-progress-outter-fill-background-color) ${currentAngle}deg,
      var(--${PREFIX_BS}step-progress-outter-background-color) 0deg)`, [currentAngle]);
    return (_jsxs("div", { className: classNames('d-stepper', className), style: style, children: [_jsx("div", { className: "d-step-bar", style: { background: progressStyle }, children: _jsx("p", { className: "d-step-number", children: `${currentStep}/${options.length}` }) }), _jsx("div", { className: "d-step-info", children: Object.keys(currentOption).length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { className: "d-step-label", children: currentOption.label }), _jsx("div", { className: "d-step-description", children: currentOption.description || '' })] })) })] }));
}
//# sourceMappingURL=DStepperMobile.js.map